import { SettingsToggleCard } from '@/components/molecules'
import { useTranslation } from 'react-i18next'

type TotalsViewToggleProps = {
    value: boolean
    onChange: (value: boolean) => void
}

export const TotalsViewToggle: React.FC<TotalsViewToggleProps> = (props) => {
    const { value, onChange } = props
    const { t } = useTranslation('translations')

    return (
        <SettingsToggleCard
            checked={value}
            onChange={onChange}
            title={t('sustainability.report_settings.totals_view.label')}
            description={t(
                'sustainability.report_settings.totals_view.description'
            )}
        />
    )
}
